import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoChevronUp = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>ChevronUp</title>
    <path
      d="M6.285 19.27 16 9.557l9.714 9.713"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoChevronUp;
